import type { RxJsonSchema } from 'rxdb';
import type { SignAndStampUserConsent } from './signAndStampUserConsent.types';

export const signAndStampUserConsentSchema: RxJsonSchema<SignAndStampUserConsent> = {
  type: 'object',
  version: 0,
  description: 'describes sign and stamp user consent data',
  primaryKey: 'pk_UserSignAndStampConsentData',
  properties: {
    pk_UserSignAndStampConsentData: { type: 'string', maxLength: 36 },
    userConsentData: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    createdBy: { type: ['string', 'null'] },
    modifiedBy: { type: ['string', 'null'] },
  },
};
